export default "__VITE_ASSET__D1ehyw3e__"